export const getFlyout = state => state.flyout;

export const selectFlyoutTitle = state => state.flyout.title;

export const selectShowFlyout = state => state.flyout.show || false;

export const getAlert = state => state.alert;
